import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = { class: "card mt-2" }
const _hoisted_8 = { class: "card-body text-center" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_11 = { class: "h1" }
const _hoisted_12 = { class: "h5 text-muted" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_16 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_17 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_18 = { class: "card mt-3" }
const _hoisted_19 = {
  key: 0,
  class: "card-body"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "card-body text-center" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = { class: "text-dark" }
const _hoisted_24 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "h1" }
const _hoisted_28 = { class: "card mt-3" }
const _hoisted_29 = {
  key: 0,
  class: "card-body"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "card-body text-center" }
const _hoisted_32 = { class: "card-title" }
const _hoisted_33 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "h1" }
const _hoisted_37 = { class: "card mt-3" }
const _hoisted_38 = {
  key: 0,
  class: "card-body"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "card-body text-center" }
const _hoisted_42 = { class: "card-title" }
const _hoisted_43 = { class: "h1" }
const _hoisted_44 = { class: "h5 text-muted" }
const _hoisted_45 = { class: "text-left" }
const _hoisted_46 = { class: "text-muted" }
const _hoisted_47 = { class: "text-muted" }

import { computed, onMounted, onBeforeUnmount, watch, nextTick, ref, shallowReactive, type Ref } from 'vue'
    import { useRoute, onBeforeRouteLeave } from 'vue-router'

    import { numCompare, SavingState, toPercentageString, toStringSmartly } from '@common/Common'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue'
    import ProjectsSelectionView from "@Quest/PortfolioScenarios/Components/ProjectsSelectionView.vue"

    import { ProjectAcceptance } from '@common/types'
    import { KendoChart, KendoChartDataSerie, KendoChartOptions } from '@Kendo/Components/KendoChart'

    import { ProjectAcceptanceDTO } from "@Quest/PortfolioScenarios/dtos"
    import { useSelectionPageQueryV1} from '@Quest/PortfolioScenarios/queries-vue-composables'
    import { useUpdateScenarioAcceptancesCommandV1 } from '@Quest/PortfolioScenarios/commands-vue-composables'

    import type {
        SelectionCostConstraintReadModel,
        SelectionCriterionReadModel,
        SelectionPageReadModel,
        SelectionProjectReadModel,
        SelectionResourceConstraintReadModel
    } from '@Quest/PortfolioScenarios/readmodels'

    import { UpdateScenarioAcceptancesCommandV1 } from '../commands-core'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectionPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params?.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params?.scenarioId ?? ''))

    const {
        runSelectionPageQueryV1,
        modelSelectionPageQueryV1
    } = useSelectionPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelSelectionPageQueryV1 as Ref<SelectionPageReadModel | null>
    const portfolioId = computed(() => rm.value?.PortfolioId)


    // ======================
    // Command
    // ======================

    const {
        invokeUpdateScenarioAcceptancesCommandV1,
        onSucceedUpdateScenarioAcceptancesCommandV1,
        command: updateScenarioAcceptancesCommandV1
    } = useUpdateScenarioAcceptancesCommandV1(workspaceId, portfolioId, scenarioId)


    // ======================
    // Local State
    // ======================

    const projects = ref<SelectionProjectReadModel[] | null>(null)

    const searchPhrase = ref<string | null>(null)
    const projectsFilter = ref<string>('All')

    const criteriaSectionExpanded = ref(false)
    const constraintsSectionExpanded = ref(false)
    const resourcesSectionExpanded = ref(false)

    const savingState = ref<SavingState>(SavingState.Saved)

    let autoSaveHandle: NodeJS.Timeout | null = null


    // ======================
    // Computed
    // ======================

    const filteredProjects = computed(() =>
    {
        let view = new Array(...(projects.value ?? []))

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1)
        }

        switch (projectsFilter.value)
        {
            case 'Accepted':
                return view.filter(a => a.UiAcceptance === ProjectAcceptance.Accepted)
            case 'Rejected':
                return view.filter(a => a.UiAcceptance === ProjectAcceptance.Rejected)
            case 'TBD':
                return view.filter(a => a.UiAcceptance === ProjectAcceptance.TBD)
            default:
                return view
        }
    })

    const topCriteria = computed<SelectionCriterionReadModel[]>(() =>
        rm.value?.Criteria.filter(a => a.IsTop === true) ?? []
    )


    // ======================
    // Formatters
    // ======================

    function fmtNum(val: number | null)
    {
        return toStringSmartly(val)
    }

    function fmtPct(val: number | null)
    {
        return toPercentageString(val)
    }


    // ======================
    // Constraint styling
    // ======================

    function getResourceCardClass(r: SelectionResourceConstraintReadModel)
    {
        if (r.Limit == null) return ''
        const ratio = r.Allocation / r.Limit
        if (ratio > 1) return 'over-limit'
        if (ratio > 0.85) return 'near-limit'
        return ''
    }

    function getCostCardClass(r: SelectionCostConstraintReadModel)
    {
        if (r.Limit == null) return ''
        const ratio = r.Allocation / r.Limit
        if (ratio > 1) return 'over-limit'
        if (ratio > 0.85) return 'near-limit'
        return ''
    }

    function handleAcceptSelection(p: SelectionProjectReadModel)
    {
        p.UiAcceptance =
            p.UiAcceptance === ProjectAcceptance.Accepted
                ? ProjectAcceptance.TBD
                : ProjectAcceptance.Accepted

        savingState.value = SavingState.Pending
    }

    function handleRejectSelection(p: SelectionProjectReadModel)
    {
        p.UiAcceptance =
            p.UiAcceptance === ProjectAcceptance.Rejected
                ? ProjectAcceptance.TBD
                : ProjectAcceptance.Rejected

        savingState.value = SavingState.Pending
    }

    function handleLockSelection(p: SelectionProjectReadModel)
    {
        p.UiAcceptanceLocked = true
        savingState.value = SavingState.Pending
    }

    function handleUnlockSelection(p: SelectionProjectReadModel)
    {
        p.UiAcceptanceLocked = false
        savingState.value = SavingState.Pending
    }

    function handleUpdateScenarioAcceptancesCommand()
    {
        if (savingState.value !== SavingState.Pending || !projects.value) return

        const acceptances: ProjectAcceptanceDTO[] = projects.value
            .filter(a =>
                a.UiAcceptance !== a.DbAcceptance ||
                a.UiAcceptanceLocked !== a.DbAcceptanceLocked
            )
            .map(a =>
            {
                const x = new ProjectAcceptanceDTO()
                x.Acceptance = a.UiAcceptance
                x.Id = a.Id
                x.Lock = a.UiAcceptanceLocked
                return x
            })

        if (!acceptances.length) return

        invokeUpdateScenarioAcceptancesCommandV1({ Acceptances: acceptances })
        savingState.value = SavingState.InProgress
    }

    function onSelected(result: any)
    {
        projects.value = null;
        runSelectionPageQueryV1();
    }

    function onScenarioUpdated()
    {
        projects.value = null;
        runSelectionPageQueryV1();
    }

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Selection"
        runSelectionPageQueryV1()

        autoSaveHandle = setInterval(
            () => handleUpdateScenarioAcceptancesCommand(),
            10000
        )
    })

    watch(rm, async (model) =>
    {
        if (!model) return

        if (projects.value == null)
        {
            projects.value = model.Projects
        }

        EfficientFrontier.SetData(projects.value, model.CurrencyLabel)
        PrioritizationMatrix.SetData(projects.value, model.CurrencyLabel)

        await nextTick()

        EfficientFrontier.Render()
        PrioritizationMatrix.Render()
    })

    onSucceedUpdateScenarioAcceptancesCommandV1(() =>
    {
        savingState.value = SavingState.Saved

        const cmd = updateScenarioAcceptancesCommandV1.value as UpdateScenarioAcceptancesCommandV1

        for (const acc of cmd.Acceptances)
        {
            const project = projects.value.find(p => p.Id === acc.Id)

            if (project)
            {
                project.DbAcceptance = acc.Acceptance as ProjectAcceptance
                project.DbAcceptanceLocked = acc.Lock
            }
        }

        runSelectionPageQueryV1()
    })


    onBeforeUnmount(() =>
    {
        if (autoSaveHandle) clearInterval(autoSaveHandle)
    })

    onBeforeRouteLeave(() =>
    {
        handleUpdateScenarioAcceptancesCommand()
    })


    class EfficientFrontierChart
    {
        isRendered: boolean = false;

        Chart: KendoChart;

        constructor()
        {
            const options = new KendoChartOptions();
            options.HideLegend();
            options.SetPannable(true);
            options.SetZoomable(true);
            options.SetTooltip(false, '#= dataItem.Name #');
            //options.SetOnSeriesHover(this.page.Highlight);
            //options.SetOnSeriesClick(this.page.OnSeriesClick);

            const chart = KendoChart.CreateScatterChart(options);
            this.Chart = chart;
        }

        SetData(projects: SelectionProjectReadModel[], currencyLabel: string)
        {

            let dataItems: { AlternativeId: string, Name: string, Acceptance: ProjectAcceptance, Color: string | null, X: number, Y: number, Z: number, TooltipHtml: string }[] = [];

            for (const alternativeVM of projects)
            {
                const xValue = alternativeVM.TotalCost;
                const yValue = alternativeVM.TotalValue;
                const zValue = alternativeVM.CostOfValuePoint;

                dataItems.push({
                    Name: alternativeVM.Name,
                    X: xValue as number,
                    Y: yValue as number,
                    Z: zValue as number,
                    AlternativeId: alternativeVM.Id,
                    Acceptance: alternativeVM.DbAcceptance,
                    Color: null,
                    TooltipHtml: `${alternativeVM.Name}`
                });
            }

            dataItems = dataItems.filter(a => a.X != null && a.Y != null && a.Z != null).sort((a, b) => numCompare(a.Z, b.Z));

            for (let i = 1; i < dataItems.length; i++) //from 1 to skip first
            {
                dataItems[i].X += dataItems[i - 1].X;
                dataItems[i].Y += dataItems[i - 1].Y;
            }

            const accepted = new KendoChartDataSerie();
            accepted.SetXField("X");
            accepted.SetYField("Y");
            accepted.SetCategoryField("Name");
            //serie.SetColorField("Color");
            accepted.SetColor("#28a745");
            accepted.SetMarkers(true, "circle"); // circle, square, triangle, cross
            accepted.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.Accepted));

            const rejected = new KendoChartDataSerie();
            rejected.SetXField("X");
            rejected.SetYField("Y");
            rejected.SetCategoryField("Name");
            //serie.SetColorField("Color");
            rejected.SetColor("#dc3545");
            rejected.SetMarkers(true, "cross"); // circle, square, triangle, cross
            rejected.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.Rejected));

            const tbd = new KendoChartDataSerie();
            tbd.SetXField("X");
            tbd.SetYField("Y");
            tbd.SetCategoryField("Name");
            //serie.SetColorField("Color");
            tbd.SetColor("#FFA500");
            tbd.SetMarkers(true, "triangle"); // circle, square, triangle, cross
            tbd.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.TBD));

            const series: KendoChartDataSerie[] = [accepted, rejected, tbd];


            const options = this.Chart.GetOptions();
            options.SetTooltip(true, "#= dataItem.TooltipHtml #");

            const xMaxValue = Math.max(...dataItems.map(v => v.X));
            const yMaxValue = Math.max(...dataItems.map(v => v.Y));

            const xAxisMin = 0;
            const xAxisMax = xMaxValue * 1.1;
            const yAxisMin = 0;
            const yAxisMax = yMaxValue * 1.1;

            const xAxisLabelFormat = xMaxValue > 10 ? "{0:n0}" : null;
            const yAxisLabelFormat = yMaxValue > 10 ? "{0:n0}" : null;

            const xCrosshairTooltipTemplate = xMaxValue ? (e: any): string => kendo.toString(e.value / xMaxValue, "p0") : undefined;
            const yCrosshairTooltipTemplate = yMaxValue ? (e: any): string => kendo.toString(e.value / yMaxValue, "p0") : undefined;

            options.SetXAxis(null, xAxisMin, xAxisMax, `Cost (${currencyLabel})`, xAxisLabelFormat, 2, true, true, null, xCrosshairTooltipTemplate);
            options.SetYAxis(null, yAxisMin, yAxisMax, "Value", yAxisLabelFormat, true, true, null, yCrosshairTooltipTemplate);

            this.Chart.SetOptions(options);
            this.Chart.SetDataSeries(series);

            this.Chart.UpdateOptions();
        }

        Render()
        {
            if (this.isRendered === false)
            {
                this.Chart.Render1("EfficientFrontier");
                this.isRendered = true;
            }
        }
    }

    class PrioritizationMatrixChart
    {
        isRendered: boolean = false;

        Chart: KendoChart;

        constructor()
        {
            const options = new KendoChartOptions();
            options.HideLegend();
            options.SetPannable(true);
            options.SetZoomable(true);
            options.SetTooltip(false, '#= dataItem.Name #');
            //options.SetOnSeriesHover(this.page.Highlight);
            //options.SetOnSeriesClick(this.page.OnSeriesClick);

            const chart = KendoChart.CreateScatterChart(options);
            this.Chart = chart;
        }

        SetData(projects: SelectionProjectReadModel[], currencyLabel: string)
        {
            let dataItems: { AlternativeId: string, Name: string, Acceptance: ProjectAcceptance, Color: string | null, X: number, Y: number, TooltipHtml: string }[] = [];

            for (const alternativeVM of projects)
            {
                const xValue = alternativeVM.TotalCost;
                const yValue = alternativeVM.TotalValue;

                dataItems.push({
                    Name: alternativeVM.Name,
                    X: xValue as number,
                    Y: yValue as number,
                    AlternativeId: alternativeVM.Id,
                    Acceptance: alternativeVM.DbAcceptance,
                    Color: null,
                    TooltipHtml: `${alternativeVM.Name}`
                });
            }

            dataItems = dataItems.filter(a => a.X != null && a.Y != null);

            const accepted = new KendoChartDataSerie();
            accepted.SetXField("X");
            accepted.SetYField("Y");
            accepted.SetCategoryField("Name");
            //serie.SetColorField("Color");
            accepted.SetColor("#28a745");
            accepted.SetMarkers(true, "circle"); // circle, square, triangle, cross
            accepted.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.Accepted));

            const rejected = new KendoChartDataSerie();
            rejected.SetXField("X");
            rejected.SetYField("Y");
            rejected.SetCategoryField("Name");
            //serie.SetColorField("Color");
            rejected.SetColor("#dc3545");
            rejected.SetMarkers(true, "cross"); // circle, square, triangle, cross
            rejected.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.Rejected));

            const tbd = new KendoChartDataSerie();
            tbd.SetXField("X");
            tbd.SetYField("Y");
            tbd.SetCategoryField("Name");
            //serie.SetColorField("Color");
            tbd.SetColor("#FFA500");
            tbd.SetMarkers(true, "triangle"); // circle, square, triangle, cross
            tbd.SetData(dataItems.filter(a => a.Acceptance === ProjectAcceptance.TBD));

            const series: KendoChartDataSerie[] = [accepted, rejected, tbd];

            const options = this.Chart.GetOptions();
            options.SetTooltip(true, "#= dataItem.TooltipHtml #");

            const xMaxValue = Math.max(...dataItems.map(v => v.X));
            const yMaxValue = Math.max(...dataItems.map(v => v.Y));

            const xAxisMin = 0;
            const xAxisMax = xMaxValue * 1.1;
            const yAxisMin = 0;
            const yAxisMax = yMaxValue * 1.1;

            const xAxisLabelFormat = xMaxValue > 10 ? "{0:n0}" : null;
            const yAxisLabelFormat = yMaxValue > 10 ? "{0:n0}" : null;

            options.SetXAxis(null, xAxisMin, xAxisMax, `Cost (${currencyLabel})`, xAxisLabelFormat, 2, true, false, null);
            options.SetYAxis(null, yAxisMin, yAxisMax, "Value", yAxisLabelFormat, true, false, null);

            this.Chart.SetOptions(options);
            this.Chart.SetDataSeries(series);

            this.Chart.UpdateOptions();
        }

        Render()
        {
            if (this.isRendered === false)
            {
                this.Chart.Render1("PrioritizationMatrix");
                this.isRendered = true;
            }
        }
    }

    const EfficientFrontier = shallowReactive(new EfficientFrontierChart())
    const PrioritizationMatrix = shallowReactive(new PrioritizationMatrixChart())

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(rm).PortfolioName) + " / " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[9] || (_cache[9] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Plan: Selection", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PortfolioScenarioNavigation, {
                portfolioId: _unref(rm).PortfolioId,
                corporateScenarioUrl: _unref(rm).CorporateScenarioUrl,
                onSelected: onSelected,
                onSelectorOpened: handleUpdateScenarioAcceptancesCommand,
                onSettingsOpened: handleUpdateScenarioAcceptancesCommand,
                onScenarioUpdated: onScenarioUpdated
              }, null, 8 /* PROPS */, ["portfolioId", "corporateScenarioUrl"])
            ])
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Metrics, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                key: m.Id
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(m.Title), 1 /* TEXT */),
                    _createElementVNode("h6", _hoisted_10, _toDisplayString(m.Subtitle), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(m.PlannedValueString ?? ' '), 1 /* TEXT */),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(m.PlannedPercentageString ?? ' '), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "my-3" }, null, -1 /* CACHED */)),
                      _createElementVNode("h6", null, [
                        _createTextVNode("All: " + _toDisplayString(m.RequestedValueString) + " ", 1 /* TEXT */),
                        (m.RequestedPercentageString)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_14, "(" + _toDisplayString(m.RequestedPercentageString) + ")", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("h6", null, [
                        _createTextVNode("Accepted: " + _toDisplayString(m.AcceptedValueString ?? 'NA') + " ", 1 /* TEXT */),
                        (m.AcceptedPercentageString)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_15, "(" + _toDisplayString(m.AcceptedPercentageString) + ")", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("h6", null, [
                        _createTextVNode("Rejected: " + _toDisplayString(m.RejectedValueString ?? 'NA') + " ", 1 /* TEXT */),
                        (m.RejectedPercentageString)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_16, "(" + _toDisplayString(m.RejectedPercentageString) + ")", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("h6", null, [
                        _createTextVNode("TBD: " + _toDisplayString(m.TbdValueString ?? 'NA') + " ", 1 /* TEXT */),
                        (m.TbdPercentageString)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_17, "(" + _toDisplayString(m.TbdPercentageString) + ")", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "card-header pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (resourcesSectionExpanded.value = !resourcesSectionExpanded.value))
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("h5", null, "Resources", -1 /* CACHED */)
            ]))]),
            (resourcesSectionExpanded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).ResourceConstraints, (r) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                        key: r.Id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card mt-1", getResourceCardClass(r)])
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h5", _hoisted_22, [
                              _createCommentVNode("{{r.Name}} <small>{{r.Unit}}</small>"),
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_23, [
                                _createTextVNode(_toDisplayString(r.Name) + " ", 1 /* TEXT */),
                                _createElementVNode("small", null, _toDisplayString(r.Unit), 1 /* TEXT */)
                              ])), [
                                [_directive_sanitizedHref, `/#/portfolio-plan/resource/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}/${r.Id}`]
                              ])
                            ]),
                            _createElementVNode("h6", _hoisted_24, [
                              (r.Limit != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(fmtPct(r.Allocation/r.Limit)), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
                            ]),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(fmtNum(r.Allocation)), 1 /* TEXT */)
                          ])
                        ], 2 /* CLASS */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: "card-header pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (constraintsSectionExpanded.value = !constraintsSectionExpanded.value))
            }, [
              _createElementVNode("h5", null, "Costs (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
            ]),
            (constraintsSectionExpanded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).CostConstraints, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                        key: c.Id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card mt-1", getCostCardClass(c)])
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("h5", _hoisted_32, _toDisplayString(c.Name), 1 /* TEXT */),
                            _createElementVNode("h6", _hoisted_33, [
                              (c.Limit != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(fmtPct(c.Allocation/c.Limit)), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
                            ]),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(fmtNum(c.Allocation)), 1 /* TEXT */)
                          ])
                        ], 2 /* CLASS */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              class: "card-header pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (criteriaSectionExpanded.value = !criteriaSectionExpanded.value))
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("h5", null, "Criteria", -1 /* CACHED */)
            ]))]),
            (criteriaSectionExpanded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topCriteria.value, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-sm-6 col-md-4 col-lg-3 col-xl-2",
                        key: c.Id
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("h5", _hoisted_42, _toDisplayString(c.Name), 1 /* TEXT */),
                            _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "card-subtitle mb-2 text-muted" }, "Value points", -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_43, _toDisplayString(c.TotalWeightedValueString ?? ' '), 1 /* TEXT */),
                            _createElementVNode("span", null, [
                              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(c.BalanceRatioString), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "my-3" }, null, -1 /* CACHED */)),
                              _createElementVNode("h6", null, [
                                _createTextVNode("Overall value: " + _toDisplayString(_unref(rm).TotalAcceptedValueString) + " ", 1 /* TEXT */),
                                _cache[15] || (_cache[15] = _createElementVNode("small", { class: "text-muted" }, "(100%)", -1 /* CACHED */))
                              ]),
                              _createElementVNode("h6", null, [
                                _createTextVNode("Criterion value: " + _toDisplayString(c.TotalWeightedValueString) + " ", 1 /* TEXT */),
                                _createElementVNode("small", _hoisted_46, "(" + _toDisplayString(c.ValueShareString) + ")", 1 /* TEXT */)
                              ]),
                              _createElementVNode("h6", null, [
                                _createTextVNode("Balanced value: " + _toDisplayString(c.BalancedWeightedValueString) + " ", 1 /* TEXT */),
                                _createElementVNode("small", _hoisted_47, "(" + _toDisplayString(c.GlobalWeightString) + ")", 1 /* TEXT */)
                              ]),
                              _createElementVNode("h6", null, "Balance ratio: " + _toDisplayString(c.BalanceRatioString), 1 /* TEXT */)
                            ])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row mt-3" }, [
            _createElementVNode("div", { class: "col-lg-6 col-md-12" }, [
              _createElementVNode("div", { class: "card" }, [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("div", { class: "float-right" }, [
                    _createElementVNode("div", { class: "dropdown d-inline mr-2" }, [
                      _createElementVNode("button", {
                        "data-toggle": "dropdown",
                        class: "btn btn-secondary btn-sm"
                      }, "Legend"),
                      _createElementVNode("div", {
                        class: "dropdown-menu dropdown-menu-right",
                        role: "menu"
                      }, [
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-xmark text-danger",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" Rejected ")
                        ]),
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-play fa-rotate-270 text-warning",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" TBD ")
                        ]),
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-circle text-success",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" Accepted ")
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("h5", null, "Efficient Frontier")
                ]),
                _createElementVNode("div", { class: "card-body chart-container" }, [
                  _createElementVNode("div", {
                    id: "Chart-EfficientFrontier",
                    style: {"max-width":"100%","height":"100%","overflow":"auto"}
                  })
                ])
              ])
            ]),
            _createElementVNode("div", { class: "col-lg-6 col-md-12" }, [
              _createElementVNode("div", { class: "card" }, [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("div", { class: "float-right" }, [
                    _createElementVNode("div", { class: "dropdown d-inline mr-2" }, [
                      _createElementVNode("button", {
                        "data-toggle": "dropdown",
                        class: "btn btn-secondary btn-sm"
                      }, "Legend"),
                      _createElementVNode("div", {
                        class: "dropdown-menu dropdown-menu-right",
                        role: "menu"
                      }, [
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-xmark text-danger",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" Rejected ")
                        ]),
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-play fa-rotate-270 text-warning",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" TBD ")
                        ]),
                        _createElementVNode("span", { class: "dropdown-item-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-circle text-success",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" Accepted ")
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("h5", null, "Prioritization Matrix")
                ]),
                _createElementVNode("div", { class: "card-body chart-container" }, [
                  _createElementVNode("div", {
                    id: "Chart-PrioritizationMatrix",
                    style: {"max-width":"100%","height":"100%","overflow":"auto"}
                  })
                ])
              ])
            ])
          ], -1 /* CACHED */)),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createVNode(ProjectsSelectionView, {
            propProjects: filteredProjects.value,
            propCurrencyLabel: _unref(rm).CurrencyLabel,
            propAllCriteria: _unref(rm).Criteria,
            propComparableScenarios: _unref(rm).ComparableScenarios,
            propSearchPhrase: searchPhrase.value,
            propProjectsFilter: projectsFilter.value,
            onAcceptSelection: _cache[3] || (_cache[3] = ($event: any) => (handleAcceptSelection($event))),
            onRejectSelection: _cache[4] || (_cache[4] = ($event: any) => (handleRejectSelection($event))),
            onLockSelection: _cache[5] || (_cache[5] = ($event: any) => (handleLockSelection($event))),
            onUnlockSelection: _cache[6] || (_cache[6] = ($event: any) => (handleUnlockSelection($event))),
            onUpdateSearchPhrase: _cache[7] || (_cache[7] = ($event: any) => (searchPhrase.value = $event)),
            onUpdateProjectsFilter: _cache[8] || (_cache[8] = ($event: any) => (projectsFilter.value = $event))
          }, null, 8 /* PROPS */, ["propProjects", "propCurrencyLabel", "propAllCriteria", "propComparableScenarios", "propSearchPhrase", "propProjectsFilter"])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */))
  ]))
}
}

})